export const projectTabs = [
  // {
  //   title: 'Project Dashboard',
  //   tab: 'projects-dashboard',
  // },
  {
    title: 'Notes',
    tab: 'notes',
  },
  {
    title: 'RocketScan',
    tab: 'rocketscan',
  },
  {
    title: 'Crew',
    tab: 'crew',
  },
  {
    title: 'Project/Loss Info',
    tab: 'project-data',
  },
  {
    title: 'RocketDry',
    tab: 'rocketdry',
  },
  {
    title: 'RocketReports',
    tab: 'rocketreports',
  },
  {
    title: 'Documents',
    tab: 'documents',
  },
  {
    title: 'Uploads',
    tab: 'uploads',
  },
];

export const userProfileTabs = [
  {
    title: 'Account',
    tab: 'account',
  },
  {
    title: 'API Definition',
    tab: 'api-docs',
  },
  {
    title: 'API Tokens',
    tab: 'api-tokens',
  },
  {
    title: 'About RocketPlan',
    tab: 'about',
  },
  {
    title: 'Data Export',
    tab: 'data-export',
  },
];
